module.exports = __webpack_public_path__ + "dashboard.svg?61d25335abad2d4d100ca822025684b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard.svg
// module id = 247
// module chunks = 0